import { default as Alt } from 'alt';
import ChromeDebug from 'alt-utils/lib/chromeDebug';

const alt = new Alt();
ChromeDebug(alt);

alt.originalCreateActions = alt.createActions;
alt.createActions = function() {
    const actions = alt.originalCreateActions(...arguments);
    const actionCreators = Object.getOwnPropertyNames(actions).map(p => actions[p]).filter(p => typeof(p) === "function");
    for(const actionCreator of actionCreators) {
        const originalDefer = actionCreator.defer;
        actionCreator.defer = function() {
            const [justification, ...argumentsToPass] = arguments;
            if(/Justification:\s.{10,}/.test(justification)) {
                originalDefer(...argumentsToPass);
            }
            else {
                console.error("You need to justify your usage of `defer`. The first argument to the call to `defer` should be a string starting with 'Justification: '.");
            }
        }
    }
    return actions;
}

export { alt as default };
